// Blogger API Configuration
export const BLOGGER_BLOG_ID = '3334154504663892923';
export const BLOGGER_API_KEY = 'AIzaSyDHvxU95WrE4R2W8EMzR3ZPhTVEXsH_bDk';

// Blogger API Base URL
export const BLOGGER_API_BASE_URL = 'https://www.googleapis.com/blogger/v3';

// Full API endpoint for fetching posts
export const BLOGGER_POSTS_URL = `${BLOGGER_API_BASE_URL}/blogs/${BLOGGER_BLOG_ID}/posts?key=${BLOGGER_API_KEY}`;

export const YOUTUBE_API_KEY = 'AIzaSyBsw4keFb5-yxN9Ksgh8_M-hQ8zBCMfhgA';
export const YOUTUBE_CHANNEL_ID = 'UCvVuOjixE050egnWNcoSZ-Q';   
export const YOUTUBE_API_URL = `https://smartdataproxy.azurewebsites.net/api/CachedProxy?target=${encodeURIComponent(`https://www.googleapis.com/youtube/v3/search?key=${YOUTUBE_API_KEY}&channelId=${YOUTUBE_CHANNEL_ID}&part=snippet,id`)}`;

